var bootB = JSON.parse(document.getElementById('jv-hub-bootstrap-b').textContent);

// ── PHASE 2c ARMED (RETESTED), 2026-08-20 ───────────────────────────────────
// History: armed -> rolled back same day after a Cowork test
// (RESULTS-phase2c-before-after-bride-experience-2026-08-20.md) found two
// real bugs: (1) the read side (_bvSavesInit) was silently inert because
// _bvSavesBrideUidKey_ referenced an undeclared `customerId` global instead
// of `_custId` (fixed, 4 sites); (2) both save buttons could get stuck
// disabled/"Saving..." forever on a rapid double-click, because the disable
// only happened deep inside an async confirmation callback (fixed --
// _confirmNewVendors now disables synchronously at the very top, and the
// inline vision form's save button gained a missing onFail re-enable).
// Neither bug ever lost bride data -- GAS/CRM writes were always unaffected.
//
// RETESTED after both fixes (RESULTS-phase2c-retest-after-bugfixes-2026-08-20.md):
// clean pass on every item -- neither button can get stuck (double-click,
// genuine real network failure both recovered correctly), a hard refresh
// immediately after a WITH-feature save shows the fresh value with zero lag
// (the actual point of the feature, confirmed working this time), full
// field-by-field data verification passed (partner name, vision words,
// beauty notes, 3 vendor cards, card+modal agreement), zero console errors.
// Independently re-confirmed via the Worker's own health endpoint
// (https://jv-bride-saves.calm-hill-fd5b.workers.dev/) showing a real
// undrained row landed during the retest.
//
// TO ROLL BACK: set this to false and push. One line, no other change
// needed -- both _bvSavesInit and _bvSavesWrite early-return the instant
// this is not === true.
window.JV_HUB_BRIDE_SAVES = true;

document.addEventListener('DOMContentLoaded', function () {
  // Endpoint now comes from the ROUTE -> BACKEND MAP in
  // jv-bridal-hub-resilience.js (loaded blocking, before this file). This
  // file no longer hardcodes the GAS /exec URL; per-route backend changes
  // are a one-line edit there. _resolve() is only needed by the raw-fetch
  // fallback below -- the jvHubFetch path resolves the route internally.
  // FIXED 2026-08-13 (raw-GAS-URL bypass sweep): the fallback below was raw GAS. Now falls back
  // to the relay worker default too.
  function _resolve(route) {
    return (window.jvHub && window.jvHub.resolveUrl)
      ? window.jvHub.resolveUrl(route)
      : 'https://broken-truth-efdd.calm-hill-fd5b.workers.dev';
  }
  (window._JV_PREVIEW_READY || Promise.resolve(null)).then(function(_prev) {
    var _email  = (_prev && _prev.email)      ? _prev.email      : bootB.email;
    var _custId = (_prev && _prev.customerId) ? _prev.customerId : bootB.customerId;
    if (!_email || !_custId) return;
    var _jvDreamTeam = bootB.dreamTeam;

  // Routes through the shared resilience layer (15s timeout + abort), with a
  // plain native-fetch fallback if the asset failed to load.
  // opt_timeoutMs (2026-08-07): uploads need longer than the shared 15s default.
  function gasPost(route, payload, onSuccess, onError, opt_timeoutMs) {
    if (window.jvHubFetch) {
      window.jvHubFetch(route, payload, {
        email: _email, customerId: _custId,
        timeoutMs: opt_timeoutMs || undefined,
        onOk: function (d) { if (onSuccess) onSuccess(d); },
        onErr: function () { if (onError) onError(); }
      });
      return;
    }
    var body = Object.assign({ route: route, email: _email, customerId: _custId }, payload || {});
    (window._jvNativeFetch || fetch)(_resolve(route), { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body) })
      .then(function (r) {
        // Same fix as jvHubFetch (2026-08-27, XRAY audit P0): a non-2xx status
        // must not be treated as success.
        if (!r.ok) { var e = new Error('http_' + r.status); throw e; }
        return r.text();
      })
      .then(function (t) { var d = null; try { d = JSON.parse(t); } catch (e) {} if (onSuccess) onSuccess(d); })
      .catch(function (e) { if (onError) onError(e); });
  }

  // ── Vendor cache ──────────────────────────────────────────────────────────
  var _vendors = [];
  function loadVendors(cb) {
    if (_vendors.length > 0) { if (cb) cb(); return; }
    // Path A: read CDN-cached shop metafield first (~200ms). Fallback to GAS (~8s) if empty.
    try {
      var _vd = bootB.vendorDir;
      if (_vd && _vd.vendors && _vd.vendors.length) { _vendors = _vd.vendors; if (cb) cb(); return; }
    } catch (e) {}
    gasPost('bridge_bride_getVendorList', {}, function (d) {
      if (d && d.ok) _vendors = d.vendors || [];
      if (cb) cb();
    }, function () { if (cb) cb(); });
  }

  // role map: card data-role → vendor role label(s) to match against
  var _roleMap = {
    photographer: ['photographer'],
    videographer: ['videographer'],
    planner:      ['wedding planner', 'planner'],
    florist:      ['florist'],
    dress:        ['dress', 'boutique', 'designer'],
    venue:        ['venue'],
    celebrant:    ['celebrant'],
    cake:         ['cake', 'baker', 'bakery'],
    catering:     ['catering', 'caterer', 'catered', 'food service', 'chef', 'cuisine']
  };

  function matchVendors(q, role) {
    if (!q || q.length < 2) return [];
    var lq = q.toLowerCase();
    var roleTerms = role ? (_roleMap[role] || [role.toLowerCase()]) : [];
    return _vendors.filter(function (v) {
      if (v.name.toLowerCase().indexOf(lq) === -1) return false;
      if (!roleTerms.length) return true;
      var vr = (v.role || v.category || '').toLowerCase();
      return roleTerms.some(function (t) { return vr.indexOf(t) !== -1; });
    }).slice(0, 5);
  }

  // ── Autocomplete wiring (shared for gateway + inline form) ───────────────
  function wireAutocomplete(container, prefix) {
    var nameInputs = container.querySelectorAll(prefix + 'vendor-name, .jv-gw-vendor-name');
    Array.prototype.forEach.call(nameInputs, function (input) {
      var card    = input.closest('[data-role]');
      if (!card) return;
      var dropdown = card.querySelector('.jv-vision-profile__autocomplete-dropdown, .jv-gateway__autocomplete-dropdown');
      var handleIn = card.querySelector('.jv-vision-vendor-handle, .jv-gw-vendor-handle');
      var websiteIn = card.querySelector('.jv-vision-vendor-website, .jv-gw-vendor-website');
      var igIn     = card.querySelector('.jv-vision-vendor-instagram, .jv-gw-vendor-instagram');
      if (!dropdown) return;

      var cardRole = card.dataset.role || '';
      var timer = null;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (handleIn) handleIn.value = '';
        timer = setTimeout(function () {
          var matches = matchVendors(q, cardRole);
          if (!matches.length) { dropdown.style.display = 'none'; dropdown.innerHTML = ''; return; }
          dropdown.innerHTML = matches.map(function (v) {
            var imgUrl = v.profileImageUrl || v.logoUrl || '';
            var avatar = imgUrl
              ? '<img src="' + imgUrl.replace(/"/g, '') + '" alt="" loading="lazy" style="width:32px;height:32px;border-radius:50%;object-fit:cover;flex-shrink:0;background:var(--brand-bg-soft,#f6f1ee);">'
              : '<span style="width:32px;height:32px;border-radius:50%;flex-shrink:0;background:linear-gradient(135deg,var(--brand-primary,#c99591),var(--brand-primary-deep,#a9706c));color:var(--brand-bg-white,#fff);display:inline-flex;align-items:center;justify-content:center;font-family:Raleway,sans-serif;font-size:.8rem;font-weight:700;">' + (v.name.charAt(0) || 'V').toUpperCase() + '</span>';
            var displayLine = v.name;
            var roleSpan    = v.role ? '<span style="color:#9a918a;font-size:.75em;margin-left:.4em;"> · ' + v.role + '</span>' : '';
            var handleLine  = v.instagramUsername ? '<div style="font-size:.72em;color:#9a918a;margin-top:.1em;">@' + v.instagramUsername + '</div>' : '';
            var networkBadge = v.approved ? '<span style="font-size:.68em;font-family:Raleway,sans-serif;color:var(--brand-primary,#c99591);font-weight:700;margin-left:.4em;">JV Network &#10022;</span>' : '';
            return '<div class="jv-autocomplete-item" data-handle="' + v.handle.replace(/"/g, '') + '" data-name="' + v.name.replace(/"/g, '') + '" data-website="' + (v.website||'').replace(/"/g, '') + '" data-instagram="' + (v.instagram||'').replace(/"/g, '') + '" data-role="' + (v.role||'').replace(/"/g, '') + '" data-approved="' + (v.approved ? 'true' : 'false') + '" style="display:flex;align-items:center;gap:.6em;padding:.4em .6em;">' + avatar + '<div style="flex:1;min-width:0;"><div style="font-family:Raleway,sans-serif;font-size:.9em;color:var(--brand-dark,#1e1716);">' + displayLine + roleSpan + networkBadge + '</div>' + handleLine + '</div></div>';
          }).join('');
          dropdown.style.display = 'block';
        }, 200);
      });

      dropdown.addEventListener('mousedown', function (e) {
        var item = e.target.closest('.jv-autocomplete-item');
        if (!item) return;
        input.value = item.dataset.name || '';
        if (handleIn) handleIn.value = item.dataset.handle || '';
        if (websiteIn) websiteIn.value = item.dataset.website || '';
        if (igIn)      igIn.value     = item.dataset.instagram || '';
        // Pre-fill role for extra (non-fixed-role) vendor cards
        var roleIn = card.querySelector('[data-field="role"]');
        if (roleIn && !card.dataset.role && item.dataset.role) roleIn.value = item.dataset.role;
        dropdown.style.display = 'none';
        dropdown.innerHTML = '';
      });

      document.addEventListener('click', function (e) {
        if (!card.contains(e.target)) { dropdown.style.display = 'none'; }
      });
    });
  }

  // ── Collect vendor data from a container ─────────────────────────────────
  function collectVendors(container) {
    var result = {};
    var extras = [];
    // Which surface is saving? Only the gateway grid owns the extras UI, so only
    // it may legitimately clear _extras. See the data-loss guard below.
    var _isGatewayGrid = !!(container && container.id === 'jv-gw-vendors-grid');
    // Fixed-role cards (data-role set in HTML)
    var cards = container ? container.querySelectorAll('[data-role]') : [];
    Array.prototype.forEach.call(cards, function (card) {
      var role = card.dataset.role;
      if (!role) return;
      var nameEl = card.querySelector('.jv-vision-vendor-name, .jv-gw-vendor-name');
      var name   = nameEl ? nameEl.value.trim() : '';
      if (!name) return;
      var handleEl = card.querySelector('.jv-vision-vendor-handle, .jv-gw-vendor-handle');
      var webEl    = card.querySelector('.jv-vision-vendor-website, .jv-gw-vendor-website');
      var igEl     = card.querySelector('.jv-vision-vendor-instagram, .jv-gw-vendor-instagram');
      result[role] = {
        name: name,
        website:        webEl    ? webEl.value.trim()    : '',
        instagram:      igEl     ? igEl.value.trim()     : '',
        existingHandle: handleEl ? handleEl.value.trim() : ''
      };
    });
    // Dynamic extra vendor rows
    var extraContainer = document.getElementById('jv-gw-extra-vendors');
    if (extraContainer) {
      var extraCards = extraContainer.querySelectorAll('.jv-gateway__vendor-card');
      Array.prototype.forEach.call(extraCards, function (card) {
        var roleLabelEl = card.querySelector('.jv-gw-extra-role');
        var nameEl      = card.querySelector('.jv-gw-vendor-name');
        var webEl       = card.querySelector('.jv-gw-vendor-website');
        var igEl        = card.querySelector('.jv-gw-vendor-instagram');
        var role = roleLabelEl ? roleLabelEl.value.trim() : '';
        var name = nameEl     ? nameEl.value.trim()       : '';
        if (!name) return;
        extras.push({ role: role || 'other', name: name, website: webEl ? webEl.value.trim() : '', instagram: igEl ? igEl.value.trim() : '' });
      });
    }
    if (extras.length) {
      result._extras = extras;
    } else if (!_isGatewayGrid) {
      // DATA-LOSS GUARD (2026-08-19). The extras UI (#jv-gw-extra-vendors) lives
      // ONLY in the gateway modal, so an INLINE vision-form save has no extra
      // rows to rebuild _extras from and would omit the key entirely. GAS writes
      // the dream team as a WHOLE-BLOB overwrite (ClientHubAPI.gs:1346,
      // `JSON.stringify(payload.dreamTeam)`, no merge), so omitting the key
      // PERMANENTLY DELETES every custom vendor the bride added via the gateway.
      // Carry the existing extras forward instead.
      //
      // The discriminator is the CONTAINER ARG, not getElementById: the gateway
      // overlay is statically present in the page markup and merely hidden with
      // CSS, so #jv-gw-extra-vendors resolves on EVERY save, inline included.
      // (An earlier attempt at this guard tested `!extraContainer` and therefore
      // never fired at all.) Only the gateway's own grid may legitimately clear
      // extras -- there, an empty container is a real "bride removed them all".
      var _prevExtras = _resolveDreamTeam()._extras;
      if (Array.isArray(_prevExtras) && _prevExtras.length) result._extras = _prevExtras;
    }
    return result;
  }

  // ── New-vendor confirmation gate (2026-08-19) ─────────────────────────────
  // A vendor NAME field is free text with autocomplete suggestions, but
  // nothing previously stopped a bride typing past the dropdown and saving
  // anyway, existingHandle stays blank and metaobjectSync_upsertVendor_
  // falls through to a slug-handle create, which can produce a near-duplicate
  // vendor record (e.g. "Chapel Hill Retreat" typed fresh vs the pool's
  // existing "Chapel Hill Retreat" entry, if the autocomplete match was
  // missed). Per Jess's decision (2026-08-19, vendor-name-mismatch handoff,
  // BRIEFS/HANDOFF-dream-team-vendor-name-mismatch-to-role4-2026-08-19.md):
  // require an explicit confirmation step for any name with no matched
  // existingHandle, rather than silently free-submitting or only tightening
  // the backend dedup match. This does not change the role fields (those
  // were already fixed/structured, not free text), only vendor NAMES.
  function _unmatchedVendorNames(dreamTeam) {
    var names = [];
    if (!dreamTeam) return names;
    Object.keys(dreamTeam).forEach(function (role) {
      if (role === '_extras') return;
      var v = dreamTeam[role];
      if (v && v.name && !v.existingHandle) names.push(v.name);
    });
    (dreamTeam._extras || []).forEach(function (v) {
      // Extra rows have no autocomplete/handle field at all today, so every
      // extra vendor is "unmatched" by definition, still worth confirming,
      // since it's still a free-text name that could collide with the pool.
      if (v && v.name) names.push(v.name);
    });
    return names;
  }

  // Renders a small on-brand inline confirmation panel above the given
  // anchor button. onConfirm fires if the bride proceeds; nothing fires (the
  // save simply doesn't happen) if she cancels, matches "never block the
  // save silently, but never save without her saying yes" from the brief.
  // FIXED 2026-08-20 (Cowork live test, RESULTS-phase2c-before-after-bride-
  // experience-2026-08-20.md): a save could get stuck in "Saving..." forever.
  // Root cause: BOTH save click handlers (the inline vision form AND the
  // gateway modal) only set gwSubmit.disabled/visionSaveBtn.disabled INSIDE
  // the _confirmNewVendors onConfirm callback -- and when there are no
  // unmatched vendor names (the common case), onConfirm fires SYNCHRONOUSLY,
  // so the disable happens late enough that a bride double-clicking (very
  // normal on a button that visibly does nothing for several seconds while
  // GAS cold-starts) can fire the click handler a second time before the
  // first click's disable takes effect. The inline vision form's own button
  // never disabled AT ALL -- zero protection. Two in-flight saves race, and
  // whichever handler's onSuccess/onFail fires LAST silently overwrites the
  // other's cleanup, or (worse) a stray in-flight request the bride has
  // already navigated away from resolves into a detached handler that never
  // touches the (already-reset) button, which reads as "stuck" because the
  // NEXT click's disable was the one actually still standing.
  //
  // Fix: _confirmNewVendors now owns disabling the button ITSELF, at the
  // very top, SYNCHRONOUSLY, before anything else runs -- including before
  // the new-vendor confirmation dialog (if any) is even shown. A second
  // click while `anchorBtn.disabled` is already true is now a guaranteed
  // no-op (the `if (anchorBtn.disabled) return;` guard below), not a timing
  // race. Callers no longer set disabled/textContent themselves at the start
  // of their onConfirm callback -- only on completion (success/fail/cancel).
  function _confirmNewVendors(names, anchorBtn, onConfirm) {
    if (anchorBtn && anchorBtn.disabled) return; // already saving -- ignore a stray second click
    if (anchorBtn) { anchorBtn._jvPrevText = anchorBtn.textContent; anchorBtn.disabled = true; anchorBtn.textContent = 'Saving…'; }
    if (!names.length) { onConfirm(); return; }
    var existing = document.getElementById('jv-new-vendor-confirm');
    if (existing) existing.parentNode.removeChild(existing);
    var box = document.createElement('div');
    box.id = 'jv-new-vendor-confirm';
    box.style.cssText = 'margin:0.75rem 0;padding:0.85rem 1rem;border-radius:1rem;background:var(--brand-bg-soft,#f6f1ee);border:1px solid #e6dad4;font-family:Raleway,sans-serif;font-size:0.9rem;color:var(--brand-text,#2f2524);';
    var list = names.map(function (n) { return '<strong>' + String(n).replace(/</g, '&lt;') + '</strong>'; }).join(', ');
    box.innerHTML = '<div style="margin-bottom:0.6rem;">' +
      (names.length === 1 ? 'Add ' + list + ' as a new vendor?' : 'Add these as new vendors: ' + list + '?') +
      ' We could not find an exact match in our existing vendor list, confirming helps us keep things tidy.</div>' +
      '<div style="display:flex;gap:0.6rem;">' +
      '<button type="button" id="jv-new-vendor-confirm-yes" class="btn-primary" style="padding:0.5rem 1.1rem;font-size:0.85rem;">Yes, add ' + (names.length === 1 ? 'it' : 'them') + '</button>' +
      '<button type="button" id="jv-new-vendor-confirm-no" class="btn-ghost" style="padding:0.5rem 1.1rem;font-size:0.85rem;">Go back and check</button>' +
      '</div>';
    anchorBtn.parentNode.insertBefore(box, anchorBtn);
    // Bride is stopping to review the confirmation dialog, not actively
    // saving yet -- restore the button so she isn't staring at a disabled
    // "Saving..." button while she reads/decides. Re-disabled again the
    // instant she clicks Yes.
    if (anchorBtn) { anchorBtn.disabled = false; anchorBtn.textContent = anchorBtn._jvPrevText || anchorBtn.textContent; }
    document.getElementById('jv-new-vendor-confirm-yes').addEventListener('click', function () {
      box.parentNode.removeChild(box);
      if (anchorBtn) { anchorBtn.disabled = true; anchorBtn.textContent = 'Saving…'; }
      onConfirm();
    });
    document.getElementById('jv-new-vendor-confirm-no').addEventListener('click', function () {
      box.parentNode.removeChild(box);
    });
  }

  // ── Add extra vendor row ──────────────────────────────────────────────────
  var _extraVendorCount = 0;
  var addVendorBtn = document.getElementById('jv-gw-add-vendor');
  if (addVendorBtn) {
    addVendorBtn.addEventListener('click', function () {
      _extraVendorCount++;
      var extraContainer = document.getElementById('jv-gw-extra-vendors');
      if (!extraContainer) return;
      var card = document.createElement('div');
      card.className = 'jv-gateway__vendor-card';
      card.style.cssText = 'grid-column: span 2; margin-bottom: 0.25rem;';
      card.innerHTML = '<div style="display:flex;align-items:center;justify-content:space-between;gap:0.5rem;margin-bottom:0.5rem;">' +
        '<input type="text" class="jv-gateway__input jv-gw-extra-role" placeholder="e.g. DJ, Transport, Jeweller…" style="flex:1;">' +
        '<button type="button" class="jv-gateway__remove-vendor-btn" aria-label="Remove"><span aria-hidden="true">&times;</span> Remove</button>' +
        '</div>' +
        '<input type="text" class="jv-gateway__input jv-gw-vendor-name" data-field="name" placeholder="Name or studio" style="margin-bottom:0.4rem;" autocomplete="off">' +
        '<input type="url" class="jv-gateway__input jv-gw-vendor-website" data-field="website" placeholder="https://" style="margin-bottom:0.4rem;">' +
        '<input type="text" class="jv-gateway__input jv-gw-vendor-instagram" data-field="instagram" placeholder="@handle">';
      card.querySelector('.jv-gateway__remove-vendor-btn').addEventListener('click', function () {
        card.parentNode.removeChild(card);
      });
      extraContainer.appendChild(card);
    });
  }

  // ── Render completed vision state ─────────────────────────────────────────
  function renderCompletedProfile(data) {
    var wordsEl   = document.getElementById('jv-vision-words-display');
    var detailsEl = document.getElementById('jv-vision-details-display');
    if (wordsEl) {
      wordsEl.innerHTML = (data.visionWords || []).map(function (w) {
        return '<span class="jv-vision-word-badge">' + w + '</span>';
      }).join('');
    }
    if (detailsEl) {
      var parts = [];
      if (data.partnerName) parts.push('Partner: ' + data.partnerName);
      if (data.beautyNotes) parts.push(data.beautyNotes.substring(0, 120) + (data.beautyNotes.length > 120 ? '…' : ''));
      detailsEl.textContent = parts.join(' · ');
    }
    var completedEl = document.getElementById('jv-vision-completed');
    var formEl      = document.getElementById('jv-vision-form');
    var profileEl   = document.getElementById('jv-vision-profile');
    // Hide the standalone completed block — vision words live in the BVP panel now
    if (completedEl) completedEl.style.display = 'none';
    if (formEl)      formEl.style.display      = 'none';
    if (profileEl)   profileEl.style.display   = 'none';
    // Mark vision pill as done
    var pill = document.getElementById('jv-vision-pill');
    if (pill) {
      pill.classList.remove('is-todo');
      pill.classList.add('is-done');
    }
    if (typeof _renderBVP === 'function') _renderBVP(data);
    // data.dreamTeam is expected to already be a _resolveDreamTeam() result
    // (which logo-merges internally), so no second merge against a raw cache
    // here. Callers must pass a resolved value, not a raw metafield blob.
    if (typeof _renderDreamTeamVendors === 'function') _renderDreamTeamVendors(data.dreamTeam);
  }

  // ── Pre-fill inline form from existing data ───────────────────────────────
  function prefillInlineForm(d){var pn=document.getElementById('jv-vision-partner-name'),w1=document.getElementById('jv-vision-word-1'),w2=document.getElementById('jv-vision-word-2'),w3=document.getElementById('jv-vision-word-3'),rt=document.getElementById('jv-vision-routine'),ex=document.getElementById('jv-vision-experience');if(pn&&d.partnerName)pn.value=d.partnerName;var ws=d.visionWords||[];if(w1)w1.value=ws[0]||'';if(w2)w2.value=ws[1]||'';if(w3)w3.value=ws[2]||'';if(d.beautyNotes){var pts=d.beautyNotes.split('\n\n');if(rt)rt.value=pts[0]||'';if(ex)ex.value=pts[1]||'';}if(d.dreamTeam){['photographer','videographer','planner','florist'].forEach(function(r){var vd=d.dreamTeam[r];if(!vd||!vd.name)return;var c=document.querySelector('.jv-vision-profile__vendor-card[data-role="'+r+'"]');if(!c)return;var ni=c.querySelector('.jv-vision-vendor-name'),wi=c.querySelector('.jv-vision-vendor-website'),ii=c.querySelector('.jv-vision-vendor-instagram'),hi=c.querySelector('.jv-vision-vendor-handle');if(ni)ni.value=vd.name||'';if(wi)wi.value=vd.website||'';if(ii)ii.value=vd.instagram||'';if(hi)hi.value=vd.existingHandle||'';});}}

  // Prefill the gateway Step-3 vendor grid from a RESOLVED dream team.
  // 2026-08-19: this used to `return` on a role with no value, leaving whatever
  // was already in that input from a PREVIOUS modal open. Combined with the old
  // all-or-nothing source guard, that produced the reported "modal opens blank /
  // modal disagrees with the card" bug. It now writes EVERY role every time,
  // clearing to '' when the resolved team has no entry for that role, so the
  // modal is always a faithful view of _resolveDreamTeam() and never a
  // half-stale mix of two opens. Always pass _resolveDreamTeam(), never a raw cache.
  function prefillGatewayVendors(dt){var g=document.getElementById('jv-gw-vendors-grid');if(!g)return;var d=dt||{};['photographer','videographer','planner','florist','dress','venue','celebrant','cake','catering'].forEach(function(r){var v=d[r]||{};var c=g.querySelector('.jv-gateway__vendor-card[data-role="'+r+'"]');if(!c)return;var ni=c.querySelector('.jv-gw-vendor-name'),wi=c.querySelector('.jv-gw-vendor-website'),ii=c.querySelector('.jv-gw-vendor-instagram'),hi=c.querySelector('.jv-gw-vendor-handle');if(ni)ni.value=v.name||'';if(wi)wi.value=v.website||'';if(ii)ii.value=v.instagram||'';if(hi)hi.value=v.existingHandle||'';});}

  // Phase 2c Worker write (dark, see _bvSavesInit block above for the full
  // sequencing rule). Fired in PARALLEL with the GAS save below, never in
  // place of it -- GAS remains the system of record and this function's
  // onSuccess/onFail still resolve from the GAS response alone, unchanged.
  // This call's only job is to land formData durably in D1 fast, so that IF
  // the bride hard-refreshes before GAS's own write/metafield-sync lands,
  // _bvSavesInit's read has something fresh to serve. A failure here is
  // silent and non-blocking by design (REFUSE, DON'T GUESS is the Worker's
  // own contract -- this caller does not need to react to a refusal, the
  // read side already falls through safely when nothing is found).
  function _bvSavesWrite(formData) {
    if (window.JV_HUB_BRIDE_SAVES !== true) return; // dark by default
    var body = { customerEmail: _email, customerId: _custId, partnerName: formData.partnerName, visionWords: formData.visionWords, beautyNotes: formData.beautyNotes, dreamTeam: formData.dreamTeam };
    (window._jvNativeFetch || fetch)(JV_BRIDE_SAVES_WORKER_URL + '/save', {
      method: 'POST', mode: 'cors', credentials: 'omit',
      headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body)
    })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = null; try { d = JSON.parse(t); } catch (e) {}
        if (d && d.ok && d.brideUid) _bvSavesSetBrideUid_(d.brideUid);
      })
      .catch(function () { /* silent -- GAS save is the one that must succeed */ });
  }

  // ── Save vision profile (shared path) ─────────────────────────────────────
  function saveProfile(formData, statusEl, onSuccess, onFail) {
    var retry = function () { saveProfile(formData, statusEl, onSuccess, onFail); };
    if (statusEl) { statusEl.className = 'jv-hub-saving'; statusEl.textContent = 'Saving…'; }
    _bvSavesWrite(formData);
    var saveOnOk_ = function (d) {
      if (d && d.ok) {
        if (statusEl) { statusEl.className = ''; statusEl.textContent = ''; }
        if (onSuccess) onSuccess(d);
      } else {
        var msg = (d && d.error) ? d.error : "That didn't save. Please try again.";
        if (window.jvHubWarmError) window.jvHubWarmError(statusEl, retry, { message: msg });
        else if (statusEl) statusEl.textContent = msg;
        if (onFail) onFail(msg);
      }
    };
    var saveOnErr_ = function () {
      if (window.jvHubWarmError) window.jvHubWarmError(statusEl, retry);
      else if (statusEl) statusEl.textContent = "That didn't save. Please try again.";
      if (onFail) onFail('network');
    };
    // saveBrideProfile runs the heavy CRM row + bride_profile_json /
    // bride_dream_team_json metafield writes plus dream-team logo enrichment
    // (~10s+), so on a cold GAS instance it exceeds the default 15s resilience
    // timeout and shows a false save failure. Bump to 45s via jvHubFetch, same
    // fix family as doRename in jv-bridal-hub-main.js. (2026-07-08.)
    if (window.jvHubFetch) {
      window.jvHubFetch('bridge_bride_saveBrideProfile', formData, {
        email: _email, customerId: _custId,
        timeoutMs: 45000,
        onOk: saveOnOk_,
        onErr: saveOnErr_
      });
    } else {
      gasPost('bridge_bride_saveBrideProfile', formData, saveOnOk_, saveOnErr_);
    }
  }

  // ── INLINE VISION FORM — save button ─────────────────────────────────────
  var visionSaveBtn = document.getElementById('jv-vision-save-btn');
  var visionStatus  = document.getElementById('jv-vision-save-status');
  if (visionSaveBtn) {
    visionSaveBtn.addEventListener('click', function () {
      var pn   = document.getElementById('jv-vision-partner-name');
      var w1   = document.getElementById('jv-vision-word-1');
      var w2   = document.getElementById('jv-vision-word-2');
      var w3   = document.getElementById('jv-vision-word-3');
      var rt   = document.getElementById('jv-vision-routine');
      var ex   = document.getElementById('jv-vision-experience');
      var grd  = document.getElementById('jv-vision-vendors-grid');

      var beautyNotes = [(rt ? rt.value.trim() : ''), (ex ? ex.value.trim() : '')].filter(Boolean).join('\n\n');
      var formData = {
        partnerName:  pn  ? pn.value.trim()  : '',
        visionWords:  [(w1 ? w1.value.trim() : ''), (w2 ? w2.value.trim() : ''), (w3 ? w3.value.trim() : '')].filter(Boolean),
        beautyNotes:  beautyNotes,
        dreamTeam:    grd ? collectVendors(grd) : {}
      };

      // New-vendor confirmation gate (2026-08-19): any vendor name typed
      // past the autocomplete without a matched existingHandle gets an
      // explicit yes/no before saving, see _confirmNewVendors above.
      // FIXED 2026-08-20: _confirmNewVendors now disables visionSaveBtn
      // itself (see its own header comment) -- this call site MUST re-enable
      // it on BOTH success and failure, or a failed/errored save leaves the
      // button permanently stuck disabled (previously there was no onFail
      // argument at all, so a failure silently never recovered the button).
      _confirmNewVendors(_unmatchedVendorNames(formData.dreamTeam), visionSaveBtn, function () {
        saveProfile(formData, visionStatus, function (d) {
          // Confirmed save: seed the top-precedence source so the card AND the
          // modal both immediately reflect what was just saved, without waiting
          // on either metafield's independent CDN flush. Prefer the GAS-returned
          // blob (logoUrl-enriched) over raw form values when it has entries.
          var _savedDt = (d && d.dreamTeam && _dreamTeamHasEntries(d.dreamTeam)) ? d.dreamTeam : formData.dreamTeam;
          if (_savedDt) { _dtSaved = _savedDt; _jvDreamTeam = _savedDt; if (_profileCache) _profileCache.dreamTeam = _savedDt; }
          renderCompletedProfile({ visionWords: formData.visionWords, partnerName: formData.partnerName, beautyNotes: formData.beautyNotes, dreamTeam: _resolveDreamTeam() });
          visionSaveBtn.disabled = false;
          visionSaveBtn.textContent = visionSaveBtn._jvPrevText || visionSaveBtn.textContent;
        }, function () {
          visionSaveBtn.disabled = false;
          visionSaveBtn.textContent = visionSaveBtn._jvPrevText || visionSaveBtn.textContent;
        });
      });
    });
  }

  // Edit button re-opens form
  var visionEditBtn = document.getElementById('jv-vision-edit-btn');
  if (visionEditBtn) {
    visionEditBtn.addEventListener('click', function () {
      var completedEl = document.getElementById('jv-vision-completed');
      var formEl      = document.getElementById('jv-vision-form');
      if (completedEl) completedEl.style.display = 'none';
      if (formEl)      formEl.style.display      = '';
    });
  }

  var visionPill = document.getElementById('jv-vision-pill');
  if (visionPill) {
    visionPill.addEventListener('click', function () {
      var overlay = document.getElementById('jv-gateway-overlay');
      if (!overlay) return;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      showGatewayStep('jv-gateway-step-1');
      var dataNode = document.getElementById('jv-bride-profile-data');
      if (dataNode) {
        try {
          var bpd = JSON.parse(dataNode.textContent || '{}');
          var pn = document.getElementById('jv-gw-partner-name');
          if (pn && bpd.partnerName) pn.value = bpd.partnerName;
          var bpWords = (bpd.visionWords && bpd.visionWords.length) ? bpd.visionWords : [];
          ['jv-gw-word-1', 'jv-gw-word-2', 'jv-gw-word-3'].forEach(function (id, i) {
            var inp = document.getElementById(id);
            if (inp) inp.value = bpWords[i] || '';
          });
          var chipBox = document.getElementById('jv-gw-word-chips');
          if (chipBox) {
            chipBox.querySelectorAll('.jv-gateway__word-chip').forEach(function (c) {
              c.classList.toggle('is-selected', bpWords.indexOf(c.getAttribute('data-word')) !== -1);
            });
          }
          if (bpd.beautyNotes) {
            var bpParts = String(bpd.beautyNotes).split('\n\n');
            var rt = document.getElementById('jv-gw-routine');
            var ex = document.getElementById('jv-gw-experience');
            if (rt) rt.value = bpParts[0] || '';
            if (ex) ex.value = bpParts[1] || '';
          }
          if (bpd.profilePicUrl) {
            var pp = document.getElementById('jv-gw-bride-pic-preview');
            if (pp) pp.innerHTML = '<img src="' + bpd.profilePicUrl.replace(/"/g, '') + '" alt="Your photo">';
          }
        } catch (e) {}
      }
    });
  }

  // ── GATEWAY OVERLAY ──────────────────────────────────────────────────────
  var gwOverlay = document.getElementById('jv-gateway-overlay');
  var gwVendors = null; // loaded on step 3
  var _profileCache = null;

  function showGatewayStep(stepId) {
    var steps = gwOverlay ? gwOverlay.querySelectorAll('.jv-gateway__step') : [];
    Array.prototype.forEach.call(steps, function (s) { s.style.display = 'none'; });
    var target = document.getElementById(stepId);
    if (target) target.style.display = '';
    var panel = gwOverlay && gwOverlay.querySelector('.jv-gateway__panel');
    if (panel) panel.scrollTop = 0;
    // BUGFIX 2026-08-19 (BRIEFS/RESULTS-catch-silent-first-click-save-2026-08-19.md).
    // #jv-vision-profile (the OLDER inline vision-editor form, with its own
    // separate #jv-vision-save-btn) is left visible whenever a bride has used
    // the "Edit" pencil on the spotlight card (jv-bvp-edit-btn sets
    // pf.style.display=''), and nothing ever re-hid it for a RETURNING bride
    // (only the first-time-visitor branch did, ~line 950 above). If she then
    // also opens this gateway modal, both #jv-vision-save-btn (invisible-but-
    // present, zero layout size from its display:none ANCESTOR normally, but
    // NOT if that ancestor got shown) and #jv-gateway-step3-submit share the
    // exact visible text "Save my vision" and can overlap/collide, which
    // Cowork's live test confirmed as the real-mouse-click silently doing
    // nothing (a JS-level .click() on the correct element id worked fine --
    // only the real click-dispatch path was affected). Centralised here
    // (called on every gateway step transition, including open) rather than
    // at each of the 4 separate call sites that open the overlay, so no
    // future call site can reintroduce the collision by forgetting this line.
    var _oldInlineForm = document.getElementById('jv-vision-profile');
    if (_oldInlineForm) _oldInlineForm.style.display = 'none';
  }

  // Close button
  var gwClose = document.getElementById('jv-gateway-close');
  if (gwClose) {
    gwClose.addEventListener('click', function () {
      if (gwOverlay) gwOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Begin button
  var gwBegin = document.getElementById('jv-gateway-begin');
  if (gwBegin) {
    gwBegin.addEventListener('click', function () { showGatewayStep('jv-gateway-step-1'); });
  }

  // Back buttons
  var gwBack1 = document.getElementById('jv-gateway-step1-back');
  if (gwBack1) {
    gwBack1.addEventListener('click', function () { showGatewayStep('jv-gateway-step-0'); });
  }
  var gwBack2 = document.getElementById('jv-gateway-step2-back');
  if (gwBack2) {
    gwBack2.addEventListener('click', function () { showGatewayStep('jv-gateway-step-1'); });
  }
  var gwBack3 = document.getElementById('jv-gateway-step3-back');
  if (gwBack3) {
    gwBack3.addEventListener('click', function () { showGatewayStep('jv-gateway-step-2'); });
  }

  var _VENDOR_ROLES = ['photographer','videographer','planner','florist','dress','venue','celebrant','cake','catering'];
  function _dreamTeamHasEntries(dt) { return !!(dt && !Array.isArray(dt) && typeof dt === 'object' && _VENDOR_ROLES.some(function(r){return dt[r]&&dt[r].name;})); }

  // ── SINGLE RESOLVED DREAM TEAM (2026-08-19) ───────────────────────────────
  // The bride's dream team lives in TWO Shopify metafields that flush to the
  // CDN INDEPENDENTLY: custom.bride_dream_team_json (-> _jvDreamTeam) and the
  // nested copy inside custom.bride_profile_json (-> _profileCache.dreamTeam).
  // A 3rd short-lived localStorage cache ('jvbp'+customerId) also renders over
  // the read-only card. Previously the card and the edit modal each picked a
  // DIFFERENT one of those, which is why a bride could see a value on the card,
  // a BLANK field in the modal, and a third value again after a reload.
  //
  // The old guard picked ONE source all-or-nothing via _dreamTeamHasEntries(),
  // but that returns true when ANY single role has a name -- so a cache holding
  // 5 roles but missing Venue still won, and Venue silently prefilled blank
  // (prefillGatewayVendors only ever WRITES non-empty values, it never clears).
  // The failure is per-role, so the resolution has to be per-role too.
  //
  // _resolveDreamTeam() is now the ONE source both the card and the modal read.
  // Do NOT re-introduce a direct _jvDreamTeam / _profileCache.dreamTeam read at
  // a render or prefill site -- add the source to the list here instead.
  // Precedence, most-trusted first: confirmed in-memory save this pageview,
  // then the Phase 2c Worker's durable-but-undrained save (see below, dark),
  // then bride_profile_json, then bride_dream_team_json, then localStorage.
  var _dtSaved = null; // set ONLY by a confirmed successful save this pageview
  function _dtLocalCache() {
    // FIXED 2026-08-20 (Cowork live test, RESULTS-phase2c-before-after-
    // bride-experience-2026-08-20.md): this read `customerId`, an undeclared
    // bare global -- the real variable is `_custId` (declared above). The
    // ReferenceError was silently swallowed by the catch below, so this
    // cache read has been silently no-oping since it was written, with no
    // visible symptom (the other 3 sources in _resolveDreamTeam()'s
    // precedence list usually cover the same data). Same bug, same fix, at
    // 3 other sites in this file -- see the localStorage.setItem call below
    // and _bvSavesBrideUidKey_.
    try {
      var c = JSON.parse(localStorage.getItem('jvbp' + _custId) || 'null');
      if (c && c.ts && Date.now() - c.ts < 7200000 && c.v) return c.v;
    } catch (e) {}
    return null;
  }
  // ── PHASE 2c: jv-bride-saves Worker read source (dark, OFF by default) ─────
  // BRIEFS/BUILD-PLAN-phase2c-bridal-hub-local-first-saves-2026-08-19.md §5.
  // Handoff: AGENT-PROMPTS/handoffs/HANDOFF-phase2c-frontend-wiring-status-2026-08-20.md.
  //
  // _bvSavesResult holds whatever GET /vision/:bride_uid last returned this
  // pageview (or null before the fetch resolves / if it found nothing). The
  // fetch itself is fired async on load (see _bvSavesInit below) and is NEVER
  // awaited before first paint -- blocking on it would reintroduce exactly the
  // GAS-cold-start wait this migration exists to remove. When it resolves with
  // a fresher value than what already painted, the same re-render path
  // _bpHandler already uses (_resolveDreamTeam + _renderDreamTeamVendors) runs
  // again, same shape as the existing async re-paint on profile load.
  //
  // This is a PLAIN PATH-BASED FETCH, not jvHubFetch/JV_HUB_ROUTES -- the
  // Worker dispatches on url.pathname (GET /vision/:bride_uid), not on a
  // {route:...} body field the way GAS/the relay do, so the shared route-map
  // seam does not apply here (same reason _loadR2Pending below calls
  // jv-inspo-upload's Worker directly instead of through jvHubFetch). See
  // DEPOLYMENT/jv-bride-saves/worker.js for the exact contract.
  //
  // Gated on window.JV_HUB_BRIDE_SAVES === true -- a dark flag, same mechanism
  // as JV_HUB_RELAY_UPLOADS / JV_HUB_ADDON_CATALOG / JV_HUB_BRIDE_RECEIPTS
  // (jv-bridal-hub-resilience.js). Do NOT flip this flag until BOTH halves --
  // this read AND the POST /save write below -- have been verified working
  // together against a real bride save (Phase 2a's 2026-08-08 rollback is why
  // that sequencing is a hard rule here, not caution for its own sake). As of
  // 2026-08-20 the backend's own end-to-end round-trip (DRAIN_KEY secret set,
  // a real test save, JV_brideVisionSavesDrain_runNow, CRM/metafield
  // confirmed, THEN JV_brideVisionSavesDrain_enable) has not yet run --
  // verify that happened before ever setting this flag true anywhere, console
  // or code.
  var _bvSavesResult = null; // { partnerName, visionWords, beautyNotes, dreamTeam } | null
  var JV_BRIDE_SAVES_WORKER_URL = 'https://jv-bride-saves.calm-hill-fd5b.workers.dev';

  // ── D1-first write for the Beauty Blueprint / brief-extended save ─────────
  // POST /brief on jv-bride-saves. Unlike _bvSavesWrite above (a silent
  // parallel mirror of the vision save), this one is the PRIMARY path for
  // doGwSave: on success the bride is confirmed from D1 and GAS is never
  // called on the hot path -- GAS drains the row on its own minute cadence,
  // calling the existing unchanged clientApi_saveBriefExtended.
  //
  // WHY: bridge_bride_saveBriefExtended is ~8-10s of handler work on top of
  // the ~7-10s GAS cold-start floor, and already told brides "That didn't
  // save..." on saves that HAD succeeded (the client aborted at the then-15s
  // default while the write landed). Raising that to 45s made a false failure
  // rarer but a real success slower to confirm. This removes the wait.
  //
  // Direct path call, NOT jvHubFetch: this Worker dispatches on url.pathname,
  // not a {route:...} body field -- the same reason /save and /vision/ bypass
  // the shared route map. Captured native fetch is mandatory (third-party
  // Shopify apps monkey-patch fetch, promoting the request to a preflight
  // neither the Worker nor GAS serves).
  //
  // bride_uid is deliberately NOT sent: the Worker resolves it server-side and
  // ignores a client-supplied one by design, so a caller cannot write into
  // another bride's row.
  //
  // cb(true) ONLY on a genuine D1 write. Every other outcome -- network error,
  // a refusal, or {ok:false, fallback:'gas'} when the bride is not yet in the
  // CRM mirror -- calls cb(false) and the caller falls back to the existing
  // unchanged GAS save. A D1 miss must be SLOWER, never broken.
  function _briefSavesWrite(payload, cb) {
    var done = false;
    var finish = function (ok) { if (!done) { done = true; cb(ok); } };
    var body = {
      customerEmail: _email,
      customerId: _custId,
      idempotency_key: _briefIdemKey_(),
      hairstylePref: payload.hairstylePref,
      makeupVibe: payload.makeupVibe,
      hairSituationJson: payload.hairSituationJson,
      makeupSituationJson: payload.makeupSituationJson,
      markBriefComplete: payload.markBriefComplete
    };
    try {
      (window._jvNativeFetch || fetch)(JV_BRIDE_SAVES_WORKER_URL + '/brief', {
        method: 'POST', mode: 'cors', credentials: 'omit',
        headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body)
      })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var d = null; try { d = JSON.parse(t); } catch (e) {}
          // The Worker returns its refusals as HTTP 200 with {ok:false,
          // fallback:'gas'}, so the parsed body decides -- never the status.
          if (d && d.ok && d.writtenTo === 'd1') {
            if (d.brideUid) _bvSavesSetBrideUid_(d.brideUid);
            finish(true);
          } else {
            finish(false);
          }
        })
        .catch(function () { finish(false); });
    } catch (e) { finish(false); }
  }

  // Fresh key per save attempt. The Worker requires one and refuses a
  // duplicate against a genuinely different row rather than risk overwriting
  // the wrong bride, so this must never be reused across saves.
  function _briefIdemKey_() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) {}
    return 'brief-' + _custId + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }
  function _bvSavesBrideUidKey_() { return 'jvbvuid' + _custId; }
  function _bvSavesGetBrideUid_() {
    try { return localStorage.getItem(_bvSavesBrideUidKey_()) || null; } catch (e) { return null; }
  }
  function _bvSavesSetBrideUid_(uid) {
    try { if (uid) localStorage.setItem(_bvSavesBrideUidKey_(), uid); } catch (e) {}
  }
  function _bvSavesInit() {
    if (window.JV_HUB_BRIDE_SAVES !== true) return; // dark by default -- see block header
    var brideUid = _bvSavesGetBrideUid_();
    if (!brideUid) return; // no Worker save has ever confirmed for this browser yet -- nothing to read
    (window._jvNativeFetch || fetch)(JV_BRIDE_SAVES_WORKER_URL + '/vision/' + encodeURIComponent(brideUid), {
      method: 'GET', mode: 'cors', credentials: 'omit'
    })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = null; try { d = JSON.parse(t); } catch (e) {}
        // Per the Worker's own contract: found:false once GAS has drained the
        // row (steady state -- zero behaviour change), and any non-ok response
        // (network error, 500, etc.) is treated identically -- REFUSE, DON'T
        // GUESS applies to the read side too. Only a genuine found:true row
        // updates resolution.
        if (!d || !d.ok || !d.found) return;
        _bvSavesResult = { partnerName: d.partnerName, visionWords: d.visionWords, beautyNotes: d.beautyNotes, dreamTeam: d.dreamTeam };
        // Re-run the SAME resolve+render path _bpHandler uses on its own async
        // arrival, so a Worker-sourced value that lands after first paint
        // still reaches the card/modal without a reload.
        var _dtR = _resolveDreamTeam();
        if (_dreamTeamHasEntries(_dtR) && typeof _renderDreamTeamVendors === 'function') _renderDreamTeamVendors(_dtR);
        if (typeof renderCompletedProfile === 'function' && (d.partnerName || (d.visionWords && d.visionWords.length))) {
          renderCompletedProfile({ visionWords: d.visionWords || [], partnerName: d.partnerName || '', beautyNotes: d.beautyNotes || '', dreamTeam: _dtR });
        }
      })
      .catch(function () { /* silent -- falls through to the unchanged metafield chain */ });
  }
  function _resolveDreamTeam() {
    var sources = [_dtSaved, (_bvSavesResult && _bvSavesResult.dreamTeam), (_profileCache && _profileCache.dreamTeam), _jvDreamTeam, _dtLocalCache()];
    var out = {};
    _VENDOR_ROLES.forEach(function (role) {
      for (var i = 0; i < sources.length; i++) {
        var s = sources[i];
        if (s && !Array.isArray(s) && typeof s === 'object' && s[role] && s[role].name) { out[role] = s[role]; break; }
      }
    });
    // _extras is a list, not per-role: take it whole from the first source that has one.
    for (var j = 0; j < sources.length; j++) {
      var sx = sources[j];
      if (sx && !Array.isArray(sx) && typeof sx === 'object' && Array.isArray(sx._extras) && sx._extras.length) { out._extras = sx._extras; break; }
    }
    // logoUrl enrichment only ever arrives on the GAS-returned blobs, so merge
    // it back over whichever value won above.
    return _bpMergeLogo(_jvDreamTeam, out);
  }

  function _openVendorGateway() {
    if (gwOverlay) { gwOverlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    showGatewayStep('jv-gateway-step-3');
    prefillGatewayVendors(_resolveDreamTeam());
    // Load vendor autocomplete suggestions in background (non-blocking)
    loadVendors(function () {
      var grd = document.getElementById('jv-gw-vendors-grid');
      if (grd && !grd._autocompleteWired) {
        wireAutocomplete(grd, '.jv-gw-');
        grd._autocompleteWired = true;
      }
    });
  }

  // "Share your vendors" button (empty-state placeholder)
  var _addVendorsBtn = document.getElementById('jv-add-vendors-btn');
  if (_addVendorsBtn) { _addVendorsBtn.addEventListener('click', _openVendorGateway); }

  // "Edit" button on the Other Vendors section header (always visible)
  var _editVendorsBtn = document.getElementById('jv-edit-vendors-btn');
  if (_editVendorsBtn) { _editVendorsBtn.addEventListener('click', _openVendorGateway); }

  // Word chips — max 3 selectable, sync to text inputs
  var wordChipsContainer = document.getElementById('jv-gw-word-chips');
  if (wordChipsContainer) {
    wordChipsContainer.addEventListener('click', function (e) {
      var chip = e.target.closest('.jv-gateway__word-chip');
      if (!chip) return;
      var selected = wordChipsContainer.querySelectorAll('.jv-gateway__word-chip.is-selected');
      if (chip.classList.contains('is-selected')) {
        chip.classList.remove('is-selected');
      } else {
        if (selected.length >= 3) return; // max 3
        chip.classList.add('is-selected');
      }
      syncChipsToInputs();
    });
  }

  function syncChipsToInputs() {
    var selected = wordChipsContainer ? Array.prototype.map.call(
      wordChipsContainer.querySelectorAll('.jv-gateway__word-chip.is-selected'),
      function (c) { return c.getAttribute('data-word'); }
    ) : [];
    var inputs = ['jv-gw-word-1', 'jv-gw-word-2', 'jv-gw-word-3'];
    inputs.forEach(function (id, i) {
      var el = document.getElementById(id);
      if (el) el.value = selected[i] || '';
    });
  }

  function getVisionWords() {
    var selected = wordChipsContainer ? Array.prototype.map.call(
      wordChipsContainer.querySelectorAll('.jv-gateway__word-chip.is-selected'),
      function (c) { return c.getAttribute('data-word'); }
    ) : [];
    if (selected.length > 0) return selected;
    // Fallback to text inputs
    var w1 = document.getElementById('jv-gw-word-1');
    var w2 = document.getElementById('jv-gw-word-2');
    var w3 = document.getElementById('jv-gw-word-3');
    return [(w1 ? w1.value.trim() : ''), (w2 ? w2.value.trim() : ''), (w3 ? w3.value.trim() : '')].filter(Boolean);
  }

  // Step 1 → 2
  var gwStep1Next = document.getElementById('jv-gateway-step1-next');
  if (gwStep1Next) {
    gwStep1Next.addEventListener('click', function () { showGatewayStep('jv-gateway-step-2'); });
  }

  // Step 2 → 3 (load vendors when transitioning)
  var gwStep2Next = document.getElementById('jv-gateway-step2-next');
  if (gwStep2Next) {
    gwStep2Next.addEventListener('click', function () {
      showGatewayStep('jv-gateway-step-3');
      prefillGatewayVendors(_resolveDreamTeam());
      loadVendors(function () {
        var grd = document.getElementById('jv-gw-vendors-grid');
        if (grd) wireAutocomplete(grd, '.jv-gw-');
      });
    });
  }

  // Step 3 — submit
  var gwSubmit = document.getElementById('jv-gateway-step3-submit');
  var gwStatus = document.getElementById('jv-gateway-save-status');
  if (gwSubmit) {
    gwSubmit.addEventListener('click', function () {
      var grd   = document.getElementById('jv-gw-vendors-grid');
      var pn    = document.getElementById('jv-gw-partner-name');
      var rt    = document.getElementById('jv-gw-routine');
      var ex    = document.getElementById('jv-gw-experience');

      var beautyNotes = [(rt ? rt.value.trim() : ''), (ex ? ex.value.trim() : '')].filter(Boolean).join('\n\n');
      var words       = getVisionWords();
      var formData    = {
        partnerName: pn ? pn.value.trim() : '',
        visionWords: words,
        beautyNotes: beautyNotes,
        dreamTeam:   grd ? collectVendors(grd) : {}
      };

      // New-vendor confirmation gate (2026-08-19): runs BEFORE the
      // disabled/"Saving…" state, so a bride who cancels isn't left staring
      // at a stuck-disabled button, see _confirmNewVendors above.
      // FIXED 2026-08-20: _confirmNewVendors now owns disabling gwSubmit
      // itself, synchronously, at the top -- doing it again here was
      // harmless when it worked but is now REMOVED because it masked the
      // real bug (a rapid double-click could fire this whole handler twice
      // before this line ran the first time). See _confirmNewVendors's own
      // header comment for the full root-cause explanation.
      _confirmNewVendors(_unmatchedVendorNames(formData.dreamTeam), gwSubmit, function () {
        // BUGFIX 2026-08-19: this callback referenced an undefined `d` (never
        // declared as a parameter here), throwing ReferenceError right after a
        // successful save. saveProfile's onSuccess is invoked as onSuccess(d)
        // (see saveOnOk_ above), the callback just wasn't declared to receive
        // it. That crash fired AFTER the GAS write already succeeded, so it
        // never reset gwSubmit.disabled/text, leaving the button stuck and
        // masking a real success as an apparent hang/failure on retry. Found by
        // role 12 (Public Site / Marketing Theme Agent) while verifying
        // venue-region-autoflow (BRIEFS/RESULTS-venue-region-autoflow-e2e-2026-08-19.md);
        // handed off in BRIEFS/HANDOFF-bridal-hub-team-save-d-undefined-bug-2026-08-19.md.
        saveProfile(formData, gwStatus, function (d) {
          // Show completion screen
          var wordsEl = document.getElementById('jv-gateway-vision-words-display');
          if (wordsEl) {
            wordsEl.innerHTML = words.map(function (w) {
              return '<span class="jv-gateway-word-badge">' + w + '</span>';
            }).join('');
          }
          showGatewayStep('jv-gateway-completion');
          // Update in-memory cache so modal prefills correctly if re-opened before page reload
          // Prefer d.dreamTeam (enriched with logoUrls from GAS) over raw formData.dreamTeam
          var _savedDt = (d && d.dreamTeam && _dreamTeamHasEntries(d.dreamTeam)) ? d.dreamTeam : formData.dreamTeam;
          if (_savedDt) { _dtSaved = _savedDt; _jvDreamTeam = _savedDt; if (_profileCache) _profileCache.dreamTeam = _savedDt; _renderDreamTeamVendors(_resolveDreamTeam()); }
          // Also update the inline profile section
          renderCompletedProfile({ visionWords: words, partnerName: formData.partnerName, beautyNotes: formData.beautyNotes, dreamTeam: _resolveDreamTeam() });
          prefillInlineForm(formData);
          try{window.dispatchEvent(new CustomEvent('jv-bride-profile-saved',{detail:{partnerName:formData.partnerName,visionWords:words,beautyNotes:formData.beautyNotes}}));}catch(e){}
          gwSubmit.disabled = false;
          gwSubmit.textContent = 'Save my vision →';
        }, function () {
          gwSubmit.disabled = false;
          gwSubmit.textContent = 'Save my vision →';
        });
      }); // end _confirmNewVendors
    });
  }

  // Completion → party hub
  var gwGoParty = document.getElementById('jv-gateway-go-party');
  if (gwGoParty) {
    gwGoParty.addEventListener('click', function () {
      if (gwOverlay) gwOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      var partyHub = document.getElementById('jv-party-hub');
      if (partyHub) {
        partyHub.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Briefly highlight
        partyHub.style.transition = 'box-shadow 0.4s';
        partyHub.style.boxShadow = '0 0 0 3px var(--brand-primary)';
        setTimeout(function () { partyHub.style.boxShadow = ''; }, 1000);
      }
    });
  }

  // "I'll do this later"
  var gwLater = document.getElementById('jv-gateway-later');
  if (gwLater) {
    gwLater.addEventListener('click', function () {
      if (gwOverlay) gwOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // ── INSPIRATION STEPS (4-7) ──────────────────────────────────────────────
  var _bN=bootB.brideName,_iO='pill',_hL=false,_mL=false;
  function _gwClose(){if(gwOverlay)gwOverlay.classList.remove('is-open');document.body.style.overflow='';}
  function _rThumb(g,url,n,fid){var w=document.createElement('div');w.className='jv-inspo-thumb';var i=document.createElement('img');i.src=(typeof JV_driveImg==='function'?JV_driveImg(url):url);i.alt=n||'';i.loading='lazy';
    // Drive thumbnail hosts (drive.google.com/thumbnail vs lh3.googleusercontent.com)
    // serve the same file but can 403 inconsistently for a bride's cookieless
    // session. On error, fall through the alternate host(s) using the Drive fileId
    // before giving up, so an uploaded photo that resolves on one host still renders.
    if(fid){i.setAttribute('data-jv-fid',fid);i.onerror=function(){var f=i.getAttribute('data-jv-fid'),step=parseInt(i.getAttribute('data-jv-step')||'0',10);var alts=['https://drive.google.com/uc?export=view&id='+f,'https://lh3.googleusercontent.com/d/'+f];if(step<alts.length){i.setAttribute('data-jv-step',String(step+1));i.src=alts[step];}else{i.onerror=null;}};}
    w.appendChild(i);if(fid){var xb=document.createElement('button');xb.type='button';xb.className='jv-inspo-thumb__del';xb.setAttribute('aria-label','Remove photo');xb.innerHTML='<svg viewBox="0 0 10 10" width="10" height="10" fill="none" stroke="#fff" stroke-width="1.75" stroke-linecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>';xb.addEventListener('click',function(e){e.stopPropagation();xb.disabled=true;w.style.opacity='.45';gasPost('bridge_party_deleteInspoImage',{memberContext:'bride',targetMemberName:_bN,targetMemberRole:'Bride',fileId:fid},function(d){if(d&&d.ok){w.remove();}else{w.style.opacity='1';xb.disabled=false;}},function(){w.style.opacity='1';xb.disabled=false;});});w.appendChild(xb);}g.appendChild(w);}
  /* FIXED 2026-08-08: the wizard said "saved" but showed nothing on reopen.
   * This reads bridge_party_listInspoImages, the same route measured lagging a
   * just-completed upload by SEVERAL MINUTES. So a bride uploaded a photo, saw
   * it, was told "Your inspiration is saved.", reopened the wizard and found an
   * empty grid. The photo was never lost, it was in Drive the whole time; the
   * list it repaints from had simply not caught up.
   *
   * Merge the fresh-upload memory over the server list, same doctrine as the
   * party cards (jvPartyInspoMergeFresh_ in jv-bridal-hub-main.js) and the
   * bride grid (FRESH-UPLOAD CACHE in jv-bride-spotlight.liquid). The uploader
   * in this file already calls jvHubInspoRememberUpload on success; only the
   * READ side was missing, which is why remembering alone never helped.
   *
   * Additive only and self-expiring (30 min), so it cannot hide a genuine
   * deletion. Delete with the rest of the Option C stopgap once the upload
   * path writes a durable read model (Cloudflare Phase 2a).
   */
  // R2-SUPPLEMENT (2026-08-19, dark, OFF by default -- see
  // BRIEFS/HANDOFF-role4-to-role8-inspo-upload-list-route-2026-08-19.md).
  // Fetches jv-inspo-upload's GET/POST /list route -- a bride's photos that
  // are durably in R2 but have NOT YET landed in Drive (the Worker filters
  // out anything with driveStatus:'ok' server-side, so this route can never
  // duplicate what _loadPh's GAS/Drive call already returns). Merged into
  // _loadPh below, keyed on the SAME dark flag Phase 1 already uses
  // (window.JV_HUB_RELAY_UPLOADS -- see jv-bridal-hub-resilience.js), so this
  // stays a complete no-op until BOTH halves (this file + the Worker's /list
  // route, role 8's to build) are verified live together. Calling a route
  // that does not exist yet would just 404 harmlessly, but there is no reason
  // to fire it at all before the Worker half ships.
  function _loadR2Pending(cat, cb) {
    if (window.JV_HUB_RELAY_UPLOADS !== true) { cb([]); return; }
    var listUrl = 'https://jv-inspo-upload.calm-hill-fd5b.workers.dev/list';
    var body = { email: _email, customerId: _custId, category: cat };
    (window._jvNativeFetch || fetch)(listUrl, {
      method: 'POST', mode: 'cors', credentials: 'omit',
      headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body)
    })
      .then(function (r) { return r.text(); })
      .then(function (t) { var d = null; try { d = JSON.parse(t); } catch (e) {} cb((d && d.ok && d.files) ? d.files : []); })
      .catch(function () { cb([]); });
  }
  function _loadPh(cat,g){gasPost('bridge_party_listInspoImages',{memberContext:'bride',targetMemberName:_bN,targetMemberRole:'Bride',category:cat},function(d){var f=(d&&d.ok&&d.files)?d.files:[];var seen={};f.forEach(function(x){if(x&&x.fileId)seen[x.fileId]=1;});try{var fr=(window.jvHubInspoMergeFresh&&window.jvHubInspoMergeFresh({hair:[],makeup:[]}))||{hair:[],makeup:[]};var key=(cat==='Makeup')?'makeup':'hair';(fr[key]||[]).forEach(function(id){if(id&&!seen[id]){f=f.concat([{fileId:id,category:cat,thumbUrl:'https://drive.google.com/thumbnail?id='+id+'&sz=s400',url:'https://drive.google.com/file/d/'+id+'/view',name:''}]);seen[id]=1;}});}catch(e){}
    // Merge in the R2-pending supplement (dark, see _loadR2Pending above). Its
    // own fileId (an R2 key) is unique-by-construction against Drive fileIds,
    // so no seen{} collision is possible here -- the Worker's driveStatus
    // filter is what prevents a genuine duplicate, not this merge.
    _loadR2Pending(cat, function (r2Files) {
      r2Files.forEach(function (x) { if (x && x.fileId && !seen[x.fileId]) { f = f.concat([x]); seen[x.fileId] = 1; } });
      f.forEach(function (x) { if (x.category === cat) _rThumb(g, x.thumbUrl || x.url, x.name, x.fileId); });
    });
  });}
  function _upload(cat,file,g){var w=document.createElement('div');w.className='jv-inspo-thumb jv-inspo-thumb--uploading';g.appendChild(w);var r=new FileReader();r.onload=function(e){var im=new Image();im.onload=function(){var s=Math.min(1,1200/Math.max(im.width,im.height)),cv=document.createElement('canvas');cv.width=Math.round(im.width*s);cv.height=Math.round(im.height*s);cv.getContext('2d').drawImage(im,0,0,cv.width,cv.height);var b64=cv.toDataURL('image/jpeg',.82).split(',')[1];function _fail(){w.classList.remove('jv-inspo-thumb--uploading');w.className='jv-inspo-thumb jv-inspo-thumb--error';w.title="That photo didn't upload. Tap to try again.";w.innerHTML='<button type="button" class="jv-inspo-thumb__retry" aria-label="That photo did not upload. Try again">Retry</button>';var rb=w.querySelector('.jv-inspo-thumb__retry');if(rb)rb.addEventListener('click',function(){w.remove();_upload(cat,file,g);});}gasPost('bridge_party_uploadInspoImage',{memberContext:'bride',targetMemberName:_bN,targetMemberRole:'Bride',category:cat,base64Content:b64,mimeType:'image/jpeg',filename:file.name.replace(/\.[^.]+$/,'')+'.jpg'},function(d){if(d&&d.ok){w.remove();var src=d.thumbUrl||(d.fileId?'https://lh3.googleusercontent.com/d/'+d.fileId:'');_rThumb(g,src,file.name,d.fileId||null);}else{_fail();}},function(){_fail();},180000);};im.src=e.target.result;};r.readAsDataURL(file);}
  function _prefill(d){var hs=document.getElementById('jv-gw-hairstyle'),vb=document.getElementById('jv-gw-makeup-vibe');if(hs&&window.JV_HAIRSTYLE_OPTIONS){hs.innerHTML='';window.JV_HAIRSTYLE_OPTIONS.forEach(function(o){var op=document.createElement('option');op.value=o.value;op.textContent=o.label;hs.appendChild(op);});}if(hs&&d.BRIDE_HAIRSTYLE_PREF){var _hv=d.BRIDE_HAIRSTYLE_PREF;if(!Array.prototype.some.call(hs.options,function(o){return o.value===_hv;})){var _x=document.createElement('option');_x.value=_hv;_x.textContent=_hv+' (unknown)';hs.appendChild(_x);}hs.value=_hv;}if(vb&&d.BRIDE_MAKEUP_VIBE)vb.value=d.BRIDE_MAKEUP_VIBE;var hS={},mS={};try{hS=JSON.parse(d.BRIDE_HAIR_SITUATION_JSON||'{}');}catch(e){}try{mS=JSON.parse(d.BRIDE_MAKEUP_SITUATION_JSON||'{}');}catch(e){}var hm={routine:'jv-hair-sit-routine',products:'jv-hair-sit-products',heatStyling:'jv-hair-sit-heat',concerns:'jv-hair-sit-concerns',veil:'jv-hair-sit-veil'},mm={skinType:'jv-mkp-sit-skintype',allergies:'jv-mkp-sit-allergies',routine:'jv-mkp-sit-routine',favProducts:'jv-mkp-sit-favproducts'};Object.keys(hm).forEach(function(k){var el=document.getElementById(hm[k]);if(el&&hS[k])el.value=hS[k];});Object.keys(mm).forEach(function(k){var el=document.getElementById(mm[k]);if(el&&mS[k])el.value=mS[k];});if(mS.activeIngredients){var ae=document.getElementById('jv-mkp-sit-actives');if(ae)ae.querySelectorAll('.jv-gateway__word-chip').forEach(function(c){if(mS.activeIngredients.indexOf(c.getAttribute('data-val'))!==-1)c.classList.add('is-selected');});}if(typeof _bvpBriefFill==='function')_bvpBriefFill(d);}
  function _collect(){var hs=document.getElementById('jv-gw-hairstyle'),vb=document.getElementById('jv-gw-makeup-vibe'),g=function(id){return(document.getElementById(id)||{}).value||'';},ae=document.getElementById('jv-mkp-sit-actives'),ai=ae?Array.prototype.map.call(ae.querySelectorAll('.jv-gateway__word-chip.is-selected'),function(c){return c.getAttribute('data-val');}):[];var hG=document.getElementById('jv-hair-inspo-grid'),mG=document.getElementById('jv-makeup-inspo-grid'),tp=(hG?hG.querySelectorAll('.jv-inspo-thumb').length:0)+(mG?mG.querySelectorAll('.jv-inspo-thumb').length:0);return{hairstylePref:hs?hs.value:'',makeupVibe:vb?vb.value.trim():'',hairSituationJson:JSON.stringify({routine:g('jv-hair-sit-routine'),products:g('jv-hair-sit-products'),heatStyling:g('jv-hair-sit-heat'),concerns:g('jv-hair-sit-concerns'),veil:g('jv-hair-sit-veil')}),makeupSituationJson:JSON.stringify({skinType:g('jv-mkp-sit-skintype'),allergies:g('jv-mkp-sit-allergies'),activeIngredients:ai,routine:g('jv-mkp-sit-routine'),favProducts:g('jv-mkp-sit-favproducts')}),markBriefComplete:tp>0};}
  function _pillDone(){var p=document.getElementById('jv-inspo-pill');if(!p)return;p.classList.remove('is-todo');p.classList.add('is-done');var ic=p.querySelector('.jv-taskpill__icon');if(ic)ic.innerHTML='<svg viewBox="0 0 24 24" class="jv-taskicon"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';try{window.dispatchEvent(new CustomEvent('jv-is'))}catch(e){}}
  function _renderBVP(data){var panel=document.getElementById('jv-bride-bvp');if(!panel)return;if(data&&data.visionWords&&data.visionWords.length){var wEl=document.getElementById('jv-bvp-vision-words');if(wEl){wEl.innerHTML=data.visionWords.map(function(w){return'<span class="jv-vision-word-badge">'+w+'</span>';}).join('');wEl.style.display='';}}var hg=document.getElementById('jv-bvp-hair-grid'),mg=document.getElementById('jv-bvp-makeup-grid');var meta=_INSPO_META||{};if(hg&&!hg._loaded){hg._loaded=true;if(meta.hair&&meta.hair.length){meta.hair.forEach(function(fid){_rThumb(hg,'https://lh3.googleusercontent.com/d/'+fid,'',fid);});}else{_loadPh('Hair',hg);}}if(mg&&!mg._loaded){mg._loaded=true;if(meta.makeup&&meta.makeup.length){meta.makeup.forEach(function(fid){_rThumb(mg,'https://lh3.googleusercontent.com/d/'+fid,'',fid);});}else{_loadPh('Makeup',mg);}}panel.style.display='';var eb=document.getElementById('jv-bvp-edit-btn');if(eb)eb.addEventListener('click',function(){var pf=document.getElementById('jv-vision-profile'),vf=document.getElementById('jv-vision-form'),vc=document.getElementById('jv-vision-completed');if(pf)pf.style.display='';if(vf)vf.style.display='';if(vc)vc.style.display='none';if(pf)pf.scrollIntoView({behavior:'smooth',block:'start'});});}
  function _bvpBriefFill(d){var det=document.getElementById('jv-bvp-details'),rows=document.getElementById('jv-bvp-detail-rows');if(!det||!rows)return;var lines=[];var hS={},mS={};try{hS=JSON.parse(d.BRIDE_HAIR_SITUATION_JSON||'{}');}catch(e){}try{mS=JSON.parse(d.BRIDE_MAKEUP_SITUATION_JSON||'{}');}catch(e){}if(d.BRIDE_HAIRSTYLE_PREF)lines.push({l:'Hairstyle',v:d.BRIDE_HAIRSTYLE_PREF});if(d.BRIDE_MAKEUP_VIBE)lines.push({l:'Makeup vibe',v:d.BRIDE_MAKEUP_VIBE});if(mS.skinType)lines.push({l:'Skin type',v:mS.skinType});if(hS.routine)lines.push({l:'Hair routine',v:hS.routine.substring(0,120)});if(mS.routine)lines.push({l:'Skin routine',v:mS.routine.substring(0,120)});if(!lines.length)return;rows.innerHTML=lines.map(function(r){return'<div class="jv-bvp__detail-row"><span class="jv-bvp__detail-label">'+r.l+'</span><span>'+r.v+'</span></div>';}).join('');det.style.display='';}
  function _igHandle(raw){if(!raw)return'';var m=String(raw).match(/instagram\.com\/([^/?#\s]+)/);if(m)return m[1].replace(/\/$/,'');var clean=String(raw).replace(/^@/,'').trim();return clean.indexOf('.')!==-1?'':clean;}
  var _igSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>';
  function _vcardIg(raw){var h=_igHandle(raw);if(!h)return'';return'<a class="jv-vcard__ig" href="https://www.instagram.com/'+encodeURIComponent(h)+'/" target="_blank" rel="noopener" title="@'+h+'">'+_igSvg+'</a>';}
  function _vcardLogo(v){var i=(v.name||'').charAt(0).toUpperCase();if(v.logoUrl)return'<div class="jv-vcard__logo-wrap"><img class="jv-vcard__logo" src="'+v.logoUrl+'" loading="lazy" alt="" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\'"><div class="jv-vcard__logo-fallback" style="display:none;">'+i+'</div></div>';var d=v.website?v.website.split('://').pop().replace(/^www\./,'').split('/')[0]:'';if(d)return'<div class="jv-vcard__logo-wrap"><img class="jv-vcard__logo" src="https://logo.clearbit.com/'+d+'" loading="lazy" alt="" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\'"><div class="jv-vcard__logo-fallback" style="display:none;">'+i+'</div></div>';return'<div class="jv-vcard__logo-wrap"><div class="jv-vcard__logo-fallback" style="display:flex;">'+i+'</div></div>';}
  function _vendorPoolEntry(v){var h=(v.existingHandle||'').trim();if(h)for(var i=0;i<_vendors.length;i++){if(_vendors[i].handle===h)return _vendors[i];}var n=(v.name||'').toLowerCase();if(n)for(var j=0;j<_vendors.length;j++){if((_vendors[j].name||'').toLowerCase()===n)return _vendors[j];}return null;}
  function _vcardBio(bio,max){var s=(bio||'').split(/[.!?]/)[0].trim();return s.length>max?s.substring(0,max).trim()+'...':s;}
  function _renderVendorCard(v,lbl){var p=_vendorPoolEntry(v);var t=(p&&p.tier)||'C';var approved=p&&p.approved;var cls='jv-vcard'+(t==='A'?' jv-vcard--a':t==='B'?' jv-vcard--b':'');var h='<div class="'+cls+'">';if(approved)h+='<div class="jv-vendor-badge" aria-label="JV Vendor Network"><span class="jv-vb-0">&#10022;</span><span class="jv-vb-2">VENDOR<br>NETWORK</span><span class="jv-vb-3">&#10022;</span></div>';h+=_vcardLogo(v);h+='<div class="jv-vcard__role">'+lbl+'</div><div class="jv-vcard__name" title="'+v.name+'">'+v.name+'</div>';h+=_vcardIg(v.instagram||v.existingHandle);if(v.website)h+='<a class="jv-vcard__website" href="'+v.website+'" target="_blank" rel="noopener">Website</a>';return h+'</div>';}
  function _renderDreamTeamVendors(dt){var vc=document.getElementById('jv-vendor-cards'),vph=document.getElementById('jv-vendor-placeholder');if(!vc||!dt)return;var rl={photographer:'Photographer',videographer:'Videographer',planner:'Wedding Planner',florist:'Florist',dress:'Gown & Dress',venue:'Venue',celebrant:'Celebrant',cake:'Cake Designer',catering:'Catering'};var cards=[];Object.keys(rl).forEach(function(k){var v=dt[k];if(!v||!v.name)return;cards.push(_renderVendorCard(v,rl[k]));});if(dt._extras&&Array.isArray(dt._extras)){var ex=dt._extras.slice().sort(function(a,b){var ta=(_vendorPoolEntry(a)||{}).tier||'C',tb=(_vendorPoolEntry(b)||{}).tier||'C';return ta<tb?-1:ta>tb?1:0;});ex.forEach(function(v){if(!v.name)return;cards.push(_renderVendorCard(v,v.role||'Vendor'));});}if(!cards.length)return;vc.innerHTML=cards.join('');if(vph)vph.style.display='none';}
  function _bpMergeLogo(src,dst){if(!src||!dst||typeof dst!=='object'||Array.isArray(dst))return dst;var r=JSON.parse(JSON.stringify(dst));['photographer','videographer','planner','florist','dress','venue','celebrant','cake','catering'].forEach(function(k){if(src[k]&&src[k].logoUrl&&r[k]&&!r[k].logoUrl)r[k].logoUrl=src[k].logoUrl;});if(Array.isArray(r._extras)&&Array.isArray(src._extras)){r._extras.forEach(function(v,i){var s=src._extras[i];if(!v.logoUrl&&s&&s.name===v.name&&s.logoUrl)v.logoUrl=s.logoUrl;});}return r;}
  function _openS4(){if(!_hL){var g=document.getElementById('jv-hair-inspo-grid');if(g){_hL=true;_loadPh('Hair',g);}}showGatewayStep('jv-gateway-step-4');if(gwOverlay){gwOverlay.classList.add('is-open');document.body.style.overflow='hidden';}}
  function _on(id,fn){var el=document.getElementById(id);if(el)el.addEventListener('click',fn);}
  _on('jv-gateway-go-inspo',function(){_iO='completion';_openS4();});
  // jv-inspo-pill also has a click handler in jv-bridal-hub-widgets.js (expands + scrolls to the
  // Bride Spotlight card's own Inspiration section, the returning-bride path). Both listeners
  // used to fire unconditionally on every click, opening the onboarding gateway overlay AND
  // scrolling to the spotlight card at the same time -- genuinely conflicting navigation. Per
  // .claude/rules/bridal-hub.md the 7-step gateway modal is first-time-onboarding only, so this
  // listener now only opens it while onboarding is still incomplete.
  // FIXED 2026-08-30 round 3 (Grade-3 XRAY live-verify follow-up): round 2's gate checked
  // #jv-bride-bvp's DOM display state, but this was confirmed live to be unreliable -- on jfg's
  // account (a genuinely completed profile, confirmed via completedAt + real vision-word content
  // already rendered inside the panel), #jv-bride-bvp's own style.display stayed 'none' well past
  // any plausible async-load window, even though _renderBVP() had clearly already run (its
  // content was visibly present). The exact point where _renderBVP's display-flip fails to stick
  // could not be pinned down from source alone (needs live debugging, not a code read) -- so
  // rather than trust a DOM visibility side-channel a second time, this gate now reads the same
  // completion DATA directly: _profileCache (assigned unconditionally at the top of _bpHandler,
  // this file, before any rendering branches run) or the CDN-cached bootB.brideProfile bootstrap
  // object as a fallback if _profileCache hasn't resolved yet. Both carry a real completedAt
  // field the moment a profile is genuinely complete, independent of any DOM element's state.
  _on('jv-inspo-pill',function(){
    var profileCompleted=(_profileCache&&_profileCache.completedAt)||(bootB.brideProfile&&bootB.brideProfile.completedAt);
    if(profileCompleted)return;
    _iO='pill';_openS4();
  });
  _on('jv-gateway-step4-back',function(){if(_iO==='completion')showGatewayStep('jv-gateway-completion');else _gwClose();});
  _on('jv-gateway-step4-next',function(){if(!_mL){var g=document.getElementById('jv-makeup-inspo-grid');if(g){_mL=true;_loadPh('Makeup',g);}}showGatewayStep('jv-gateway-step-5');});
  _on('jv-gateway-step5-back',function(){showGatewayStep('jv-gateway-step-4');});
  _on('jv-gateway-step5-next',function(){showGatewayStep('jv-gateway-step-6');});
  _on('jv-gateway-step6-back',function(){showGatewayStep('jv-gateway-step-5');});
  _on('jv-gateway-step6-next',function(){showGatewayStep('jv-gateway-step-7');});
  _on('jv-gateway-step7-back',function(){showGatewayStep('jv-gateway-step-6');});
  _on('jv-gateway-inspo-done',function(){_gwClose();});
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && gwOverlay && gwOverlay.classList.contains('is-open')) _gwClose();
  });
  var _s7=document.getElementById('jv-gateway-step7-save'),_bs=document.getElementById('jv-gateway-brief-save-status');
  if(_s7){_s7.addEventListener('click',doGwSave);}
  function doGwSave(){_s7.disabled=true;_s7.classList.add('jv-hub-saving');_s7.textContent='Saving…';if(_bs){_bs.className='';_bs.textContent='';}var _gwOnOk=function(d){_s7.disabled=false;_s7.classList.remove('jv-hub-saving');_s7.textContent='Save your vision →';if(d&&d.ok){if(d.taskMarked)_pillDone();showGatewayStep('jv-gateway-inspo-completion');}else{if(window.jvHubWarmError)window.jvHubWarmError(_bs,doGwSave,{message:(d&&d.error)?d.error:"That didn't save. Please try again."});else if(_bs)_bs.textContent="That didn't save. Please try again.";}};var _gwOnErr=function(){_s7.disabled=false;_s7.classList.remove('jv-hub-saving');_s7.textContent='Save your vision →';if(window.jvHubWarmError)window.jvHubWarmError(_bs,doGwSave);else if(_bs)_bs.textContent="That didn't save. Please try again.";};
    // saveBriefExtended writes CRM columns + the bride_brief_json metafield sync
    // + a portal-prompt refresh (heavy CRM + metafield multi-write). This is the
    // bride's first-time gateway "Save your vision" onboarding step, the exact
    // save that was failing at the default 15s resilience timeout on a cold GAS
    // instance (false "connection may have dropped"). Bump to 45s via jvHubFetch,
    // same fix family as doRename in jv-bridal-hub-main.js. (2026-07-08.)
    var _gwPayload=_collect();// Cache what we just saved so a reload shows it even if the CDN island is
    // still serving the pre-save copy. See _gwFreshBrief_ above.
    try{_gwWriteFresh_({hairstylePref:_gwPayload.hairstylePref,makeupVibe:_gwPayload.makeupVibe,hairSituationJson:_gwPayload.hairSituationJson,makeupSituationJson:_gwPayload.makeupSituationJson});}catch(e){}
    // The GAS call, unchanged, kept verbatim as the fallback path.
    var _gwSaveViaGas=function(){if(window.jvHubFetch){window.jvHubFetch('bridge_bride_saveBriefExtended',_gwPayload,{email:_email,customerId:_custId,timeoutMs:45000,onOk:_gwOnOk,onErr:_gwOnErr});}else{gasPost('bridge_bride_saveBriefExtended',_gwPayload,_gwOnOk,_gwOnErr);}};
    // D1-first (see _briefSavesWrite). On a confirmed D1 write the bride is
    // done immediately; GAS drains the row on its own minute cadence and runs
    // the same clientApi_saveBriefExtended, including the task tick, so the
    // synthesised {ok:true} below matches what GAS would have returned.
    //
    // taskMarked is reported from the payload's own markBriefComplete rather
    // than from a GAS response, because on the D1 path there is no GAS
    // response to read -- markBriefComplete is precisely the flag GAS uses to
    // decide that tick, and it is carried through the Worker and the drain
    // unchanged.
    //
    // Anything other than a genuine D1 write falls through to _gwSaveViaGas,
    // so a Worker outage or an un-mirrored bride is slower, never broken.
    _briefSavesWrite(_gwPayload,function(okD1){if(okD1){_gwOnOk({ok:true,taskMarked:!!_gwPayload.markBriefComplete});}else{_gwSaveViaGas();}});}
  var _hIn=document.getElementById('jv-hair-photo-input');if(_hIn){_hIn.addEventListener('change',function(){var g=document.getElementById('jv-hair-inspo-grid');if(g)Array.prototype.forEach.call(_hIn.files,function(f){_upload('Hair',f,g);});_hIn.value='';});}
  var _mIn=document.getElementById('jv-makeup-photo-input');if(_mIn){_mIn.addEventListener('change',function(){var g=document.getElementById('jv-makeup-inspo-grid');if(g)Array.prototype.forEach.call(_mIn.files,function(f){_upload('Makeup',f,g);});_mIn.value='';});}
  var _ac=document.getElementById('jv-mkp-sit-actives');if(_ac){_ac.addEventListener('click',function(e){var c=e.target.closest('.jv-gateway__word-chip');if(c)c.classList.toggle('is-selected');});}
  // Path A field #1: prefer Shopify metafield (~200ms CDN) over GAS call (~8s cold). Fallback to GAS if empty.
  /* FIXED 2026-08-08: wizard said "saved" then reopened blank.
   * bootB.brief is the SERVER-RENDERED bride_brief_json island, baked at page
   * render. A save writes the metafield, but the next page load can still be
   * served the pre-save island, so the bride reopened the wizard to a blank
   * hairstyle and empty fields on data that HAD saved.
   * jvhub_fresh_<customerId> is the same localStorage key the spotlight card's
   * three saves already write (_jvWriteFreshCache_), covering exactly these
   * four fields. Read it here and let it win over a stale island for 5 minutes.
   */
  function _gwFreshBrief_(){try{var c=JSON.parse(localStorage.getItem('jvhub_fresh_'+_custId)||'null');if(!c||!c.ts||(Date.now()-c.ts)>300000)return null;return c;}catch(e){return null;}}
  function _gwWriteFresh_(patch){try{var k='jvhub_fresh_'+_custId,c=JSON.parse(localStorage.getItem(k)||'{}');c.ts=Date.now();Object.keys(patch).forEach(function(x){c[x]=patch[x];});localStorage.setItem(k,JSON.stringify(c));}catch(e){}}
  (function(){var _bm=bootB.brief||{};var _fr=_gwFreshBrief_();if(_fr){_bm={hairstylePref:(_fr.hairstylePref!==undefined?_fr.hairstylePref:_bm.hairstylePref),makeupVibe:(_fr.makeupVibe!==undefined?_fr.makeupVibe:_bm.makeupVibe),hairSituationJson:(_fr.hairSituationJson!==undefined?_fr.hairSituationJson:_bm.hairSituationJson),makeupSituationJson:(_fr.makeupSituationJson!==undefined?_fr.makeupSituationJson:_bm.makeupSituationJson)};}if(_bm&&(_bm.hairstylePref||_bm.makeupVibe||_bm.hairSituationJson||_bm.makeupSituationJson)){_prefill({ok:true,BRIDE_HAIRSTYLE_PREF:_bm.hairstylePref||'',BRIDE_MAKEUP_VIBE:_bm.makeupVibe||'',BRIDE_HAIR_SITUATION_JSON:_bm.hairSituationJson||'',BRIDE_MAKEUP_SITUATION_JSON:_bm.makeupSituationJson||''});}else{gasPost('bridge_bride_getBriefData',{},function(d){if(d&&d.ok)_prefill(d);});}})();

  // Copy share message
  var copyBtn = document.getElementById('jv-party-hub-copy-btn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var msgEl = document.getElementById('jv-party-hub-share-msg');
      var text  = msgEl ? msgEl.textContent : '';
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(function () {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = 'Copy message'; }, 2000);
        });
      }
    });
  }

  // ── PORTAL PROMPT CARD ────────────────────────────────────────────────────
  // Path A Migration 2 — read precomputed prompt from Shopify CDN-cached
  // metafield (~200ms). Daily 5am cron + save hooks keep this fresh. Falls
  // back to the GAS picker for brides not yet covered by precompute.
  function _renderPortalPrompt(prompt) {
    if (!prompt || !prompt.message) return;
    var card  = document.getElementById('jv-portal-prompt-card');
    var msgEl = document.getElementById('jv-portal-prompt-message');
    if (!card || !msgEl) return;
    msgEl.textContent = prompt.message;
    card.style.display = '';
  }

  function initPortalPrompt() {
    if (sessionStorage.getItem('jv_prompt_dismissed') === '1') return;
    try {
      var _pp = bootB.portalPrompt;
      if (_pp && _pp.message) {
        _renderPortalPrompt(_pp);
        return;
      }
    } catch (e) { /* fall through to GAS */ }
    gasPost('bridge_bride_getPortalPrompt', {}, function (d) {
      if (!d || !d.ok || !d.prompt) return;
      _renderPortalPrompt(d.prompt);
    });
  }

  // Dismiss (session-only)
  var promptDismiss = document.getElementById('jv-prompt-dismiss');
  if (promptDismiss) {
    promptDismiss.addEventListener('click', function () {
      sessionStorage.setItem('jv_prompt_dismissed', '1');
      var card = document.getElementById('jv-portal-prompt-card');
      if (card) card.style.display = 'none';
    });
  }

  // Options menu toggle
  var optionsBtn  = document.getElementById('jv-prompt-options-btn');
  var optionsMenu = document.getElementById('jv-prompt-options-menu');
  if (optionsBtn && optionsMenu) {
    optionsBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = optionsMenu.style.display !== 'none';
      optionsMenu.style.display = isOpen ? 'none' : 'block';
      optionsBtn.setAttribute('aria-expanded', String(!isOpen));
    });
    document.addEventListener('click', function () { optionsMenu.style.display = 'none'; });
  }

  // Snooze
  var snoozeBtn = document.getElementById('jv-prompt-snooze');
  if (snoozeBtn) {
    snoozeBtn.addEventListener('click', function () {
      gasPost('bridge_bride_updatePortalPrefs', { action: 'snooze' }, function (d) {
        if (d && d.ok) {
          var card = document.getElementById('jv-portal-prompt-card');
          if (card) card.style.display = 'none';
        }
      });
      if (optionsMenu) optionsMenu.style.display = 'none';
    });
  }

  // Disable
  var disableBtn = document.getElementById('jv-prompt-disable');
  if (disableBtn) {
    disableBtn.addEventListener('click', function () {
      gasPost('bridge_bride_updatePortalPrefs', { action: 'disable' }, function (d) {
        if (d && d.ok) {
          var card = document.getElementById('jv-portal-prompt-card');
          if (card) card.style.display = 'none';
        }
      });
      if (optionsMenu) optionsMenu.style.display = 'none';
    });
  }

  // ── INIT: load bride profile ──────────────────────────────────────────────
  loadVendors(function(){}); // pre-populate _vendors so tier lookup is ready on first render
  // First paint: render from the ONE resolved source. _resolveDreamTeam()
  // already folds in the localStorage fresh-cache, so the separate localStorage
  // render pass that used to sit here (and could paint a THIRD value that the
  // edit modal never saw) is no longer needed. 2026-08-19.
  (function(){ var _dt0 = _resolveDreamTeam(); if (_dreamTeamHasEntries(_dt0)) _renderDreamTeamVendors(_dt0); })();
  // Phase 2c Worker read (dark, see block above) -- fired async, never blocks
  // first paint, re-renders on arrival if it finds an undrained save.
  _bvSavesInit();

  // Path A Migration 2 — fire the portal prompt IMMEDIATELY from the embedded
  // metafield, not gated by the bride-profile load chain. The card is
  // self-contained: it reads only customer.metafields.custom.bride_portal_prompt_today_json
  // (already on the page) and has no dependency on _profileCache or the
  // bride-profile resolution. Running it inline kills the 8s+ wait that
  // brides on the slow GAS fallback path were seeing for the prompt card.
  // The existing initPortalPrompt() calls inside _bpHandler stay as a safety
  // net for older brides; calling twice is a no-op once display='' is set.
  initPortalPrompt();
  // Path A §3: read CDN-cached bride_profile_json metafield first (~200ms)
  // instead of bridge_bride_getBrideProfile gasPost (~8s cold). Falls back
  // to GAS if metafield is empty (new bride or unsync'd legacy bride).
  // Shape match: metafield carries { partnerName, visionWords, beautyNotes,
  // dreamTeam, completedAt, profilePicUrl } — same as GAS handler return + profilePicUrl.
  var _bpHandler = function (d) {
    if (!d || (d.ok === false)) { initPortalPrompt(); return; }
    // 2026-08-19: the old all-or-nothing swap here ("if d.dreamTeam has no
    // entries, take _jvDreamTeam wholesale") is superseded by _resolveDreamTeam(),
    // which merges PER ROLE and so also covers the partial case that swap missed
    // (a blob holding 5 roles but missing Venue passed the has-entries check and
    // won, blanking Venue). Assign _profileCache FIRST so the resolver sees it.
    _profileCache = d;
    var _dtResolved = _resolveDreamTeam();
    if (_dreamTeamHasEntries(_dtResolved)) {
      d.dreamTeam = _dtResolved;
      _renderDreamTeamVendors(_dtResolved);
      try { localStorage.setItem('jvbp'+_custId, JSON.stringify({ts:Date.now(), v:_dtResolved})); } catch(e) {}
    }

    // Pre-load vendor list so autocomplete is ready when bride opens step 3
    loadVendors(function () {});

    if (d.completedAt) {
      renderCompletedProfile({ visionWords: d.visionWords || [], partnerName: d.partnerName || '', beautyNotes: d.beautyNotes || '', dreamTeam: _resolveDreamTeam() });
      prefillInlineForm(d);
      initPortalPrompt();
    } else {
      var profileSecGw = document.getElementById('jv-vision-profile');
      if (profileSecGw) profileSecGw.style.display = 'none';
      if (gwOverlay) {
        gwOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        showGatewayStep('jv-gateway-step-0');
      }
      loadVendors(function () {});
    }
  };
  (function () {
    try {
      var _bpMeta = bootB.brideProfile;
      // Merge localStorage fresh cache (< 5 min) over stale CDN embed so a reload
      // immediately shows what the bride just saved without waiting for Shopify CDN flush.
      try {
        var _jvfl = JSON.parse(localStorage.getItem('jvhub_fresh_' + _custId) || 'null');
        if (_jvfl && _jvfl.ts && Date.now() - _jvfl.ts < 300000) {
          if (!_bpMeta) _bpMeta = {};
          if (_jvfl.partnerName !== undefined) _bpMeta.partnerName = _jvfl.partnerName;
          if (_jvfl.visionWords !== undefined) _bpMeta.visionWords = _jvfl.visionWords;
          if (_jvfl.beautyNotes !== undefined) _bpMeta.beautyNotes = _jvfl.beautyNotes;
        }
      } catch (_e) {}
      if (_bpMeta && (_bpMeta.partnerName || _bpMeta.completedAt || _bpMeta.beautyNotes || (_bpMeta.visionWords && _bpMeta.visionWords.length) || _bpMeta.dreamTeam)) {
        _bpHandler({
          ok:          true,
          partnerName: _bpMeta.partnerName || '',
          visionWords: _bpMeta.visionWords || [],
          beautyNotes: _bpMeta.beautyNotes || '',
          dreamTeam:   _bpMeta.dreamTeam   || null,
          completedAt: _bpMeta.completedAt || ''
        });
        return;
      }
    } catch (e) {}
    gasPost('bridge_bride_getBrideProfile', {}, _bpHandler, function () {
      initPortalPrompt();
    });
  })();
  }); // end _JV_PREVIEW_READY.then
});
